
































import Vue from 'vue'
import { SelectItem } from '@/utils/interfaces'
import ActionButton from '@/components/ActionButton.vue'
import { urltoFile } from '@/utils/functions'

export default Vue.extend({
  components: {
    appActionButton: ActionButton,
  },
  data() {
    return {
      imageSrc: '',
      videoSrc: '' as string | MediaStream,
      selectedDevice: '',
      devices: [] as SelectItem[],
      streamStarted: false,
      showVideo: true,
      constraints: {
        video: {
          width: {
            min: 1280,
            ideal: 1920,
            max: 1920,
          },
          height: {
            min: 720,
            ideal: 1080,
            max: 1080,
          },
          facingMode: 'environment',
        },
      },
      stream: null as null | MediaStream,
    }
  },
  methods: {
    async startStream(constraints: MediaStreamConstraints) {
      const stream = await navigator.mediaDevices.getUserMedia(constraints)
      this.stream = stream
      this.handleStream(stream)
    },
    handleStream(stream: MediaStream) {
      ;(this.$refs.video as Vue & { srcObject: MediaStream }).srcObject = stream
      this.streamStarted = true
    },
    onStop() {
      if (this.stream) {
        const tracks = this.stream.getVideoTracks()
        tracks.forEach(track => track.stop())
        this.streamStarted = false
      }
    },
    onPause() {
      ;(this.$refs.video as any).pause()
    },
    onClick() {
      this.showVideo = true
      if (this.streamStarted) {
        ;(this.$refs.video as Vue & { play: () => void }).play()
        return
      }
      if ('mediaDevices' in navigator && navigator.mediaDevices.getUserMedia) {
        const updatedConstraints = {
          ...this.constraints,
          deviceId: {
            exact: this.selectedDevice,
          },
        }
        this.startStream(updatedConstraints)
      }
    },
    async getCameraSelection() {
      const devices = await navigator.mediaDevices.enumerateDevices()
      const videoDevices = devices.filter(
        device => device.kind === 'videoinput',
      )
      this.devices = videoDevices.map(device => ({
        text: device.label,
        value: device.deviceId,
      }))
      if (devices.length) {
        this.selectedDevice = devices[0].deviceId
      }
    },
    async doScreenshot() {
      const canvas = document.querySelector('canvas')
      const video = document.querySelector('video')
      if (canvas && video) {
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        const context = canvas.getContext('2d')
        if (context) {
          context.drawImage(video, 0, 0)
        }
        this.imageSrc = canvas.toDataURL('image/webp')
        const blob = await urltoFile(this.imageSrc)
        this.$emit('input', blob)
        this.showVideo = false
      }
    },
  },
  watch: {
    selectedDevice() {
      const updatedConstraints = {
        ...this.constraints,
        deviceId: {
          exact: this.selectedDevice,
        },
      }
      this.startStream(updatedConstraints)
    },
  },
  mounted() {
    this.getCameraSelection()
  },
  beforeDestroy() {
    this.onStop()
  },
})
